<ng-content></ng-content>
<div class="label" [style.margin]="isHovered ? '-1px' : ''">
	<span *ngIf="widget.fromAppId" class="icon" [innerHTML]="'app' | widgetIcon"></span>
	<span class="icon" [innerHTML]="widget.type | widgetIcon"></span>
	{{widget.label}}
</div>
<div
	(wheel)="onMouseWheel($event)"
	[ngSwitch]="widget.type"
	class="content-wrapper"
	[class.type-form-textfield]="widget.type === 'formTextField'"
	[class.type-form-select]="widget.type === 'formSelect'"
	[attr.data-cy]="'stage-widget-' + widget.type"
	[style.opacity]="getOpacity(widget)"
	[style.background-color]="getColor(widget, 'background')"
	[style.border]="getBorderStyle(widget)"
	[style.border-radius]="pct2px(widget.config.cornerradius)"
	[style.text-align]="widget.config?.textFormat?.textFormat?.align || 'center'"
	[style.text-decoration]="widget.config?.textFormat?.textFormat?.underline === 'true' ? 'underline' : 'none'"
	[style.color]="widget.config?.textFormat?.textFormat?.color ? '#' + widget.config?.textFormat?.textFormat?.color : 'inherit'"
	[style.font-family]="getFontFamily(widget)"
	[style.font-weight]="widget.config?.textFormat?.textFormat?.bold === 'true' ? 'bold' : 'normal'"
	[style.font-style]="widget.config?.textFormat?.textFormat?.italic === 'true' ? 'italic' : 'normal'"
	[style.font-size]="getFontSize(widget)"
	[style.line-height]="getLineHeight(widget)"
	[style.padding]="getMargin(widget)"
	>
	<ng-container *ngSwitchCase="'image'">
		<img [src]="{id: widget.config.imageid?.datasource?.defaultValue || widget.config.imageid} | thumbnail:300:200:'url' | async" alt="" />
	</ng-container>
	<ng-container *ngSwitchCase="'video'">
		<img [src]="{id: widget.config.clipid?.datasource?.defaultValue || widget.config.clipid } | thumbnail:300:200:'url' | async" alt="" />
	</ng-container>
	<ng-container *ngSwitchCase="['textLabel', 'text', 'button'].includes(widget.type) ? widget.type : ''"><!-- Workaround to have multiple cases in ngSwitch -->
		<div class="content-edit"
			#contentEdit
			(mouseup)="onEditMouseup($event, contentEdit)"
			(mousedown)="onEditMousedown($event)"
			(paste)="onPaste($event, contentEdit)"
			(blur)="onBlur(contentEdit.innerText)"
			(clickoutside)="onBlur(contentEdit.innerText)"
			[attr.contenteditable]="contentEditable"
			[style.cursor]="contentEditable && !clickTimeout ? 'text' : 'inherit'"
			[style.align-items]="flexAlignItemsMap[widget.config?.textFormat?.textFormat?.verticalalign || 'top']"
			[innerHTML]="getTextValue(widget)"
		></div>
	</ng-container>
	<ng-container *ngSwitchCase="'formSelect'">
		<div class="form-select-wrapper">
			<select *ngIf="widget.config?.options?.length">
				<option value="" [attr.selected]="!widget?.config?.value || null">{{ widget?.config?.placeHolder }}</option>
				<option *ngFor="let option of widget.config.options; trackBy: optionTrackBy" [value]="option.value" [attr.selected]="option.value === widget.config.value || null">{{option.label}}</option>
			</select>
		</div>
	</ng-container>

	<ng-container *ngSwitchCase="'formTextField'">
		<div *ngIf="widget.config.inputType !== 'date'"
			class="content-edit"
			#contentEdit
			(mouseup)="onEditMouseup($event, contentEdit)"
			(mousedown)="onEditMousedown($event)"
			(paste)="onPaste($event, contentEdit)" 
			(blur)="onBlur(contentEdit.innerText)"
			(clickoutside)="onBlur(contentEdit.innerText)"
			[attr.contenteditable]="contentEditable"
			[style.cursor]="contentEditable && !clickTimeout ? 'text' : 'inherit'"
			[attr.data-placeholder]="getPlaceHolderTextValue(widget)"
			[innerHTML]="getTextValue(widget)"
		></div>
		
		<div *ngIf="widget.config.inputType === 'date'" class="date-container">
			<input type="date">
			<!-- Dummy calendar icon (similar to desktop version), svg to color the icon -->
			<svg xmlns="http://www.w3.org/2000/svg" [style.--height]="getLineHeight(widget)" viewBox="0 0 24 24" class="date-calendar">
				<path [attr.fill]="'#' + widget.config.textFormat.textFormat.color"
					d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
			</svg>
		</div>
	</ng-container>

	<ng-container *ngSwitchCase="'formTextArea'">
		<div class="content-edit"
			#contentEdit
			(mouseup)="onEditMouseup($event, contentEdit)"
			(mousedown)="onEditMousedown($event)"
			(paste)="onPaste($event, contentEdit)"
			(blur)="onBlur(contentEdit.innerText)"
			(clickoutside)="onBlur(contentEdit.innerText)"
			[attr.contenteditable]="contentEditable"
			[style.cursor]="contentEditable && !clickTimeout ? 'text' : 'inherit'"
			[attr.data-placeholder]="getPlaceHolderTextValue(widget)"
			[innerHTML]="getTextValue(widget)"
		></div>
	</ng-container>
</div>
